export enum ImageBankFileType {
  image = "image",
  pdf = "pdf",
  video = "video",
  other_image = "other_image",
}
